<template>
  <div class="bg">
    <div class="Index">
      <div class="banner">
        <img class="bannerBg" src="../assets/image/banner.png" />

        <img class="bannerTitle" src="../assets/image/title.png" />
        <div class="theme">
          <!-- <img class="liaoIcon" src="../assets/image/liaoIcon.png" /> -->

          <div class="themeInput">
            <input
              type="text"
              v-model="vipAccount"
              placeholder="请输入您的ID"
              v-if="!playGameStatus"
            />
            <p class="getAPPID">
              如何获取APPID?
              <span @click="toTutorial">点击这里</span>
            </p>
          </div>

          <div class="rob" @click="loginFunc"></div>

          <div class="themeContent">
            <div class="playGame" v-if="playGameStatus">
              <p class="playGameNum">剩余抽奖次数：{{ prizeNum }}</p>

              <img
                src="../assets/image/playgame.png"
                @click="playGameFunc"
                alt
              />
            </div>

            <div class="count">
              <p class="countTitle"></p>

              <div class="countdown">
                <p class="countdownTitle">今日还剩</p>

                <div class="countdownLi">{{ hours }}</div>
                <p class="countdownText">:</p>
                <div class="countdownLi">{{ minutes }}</div>
                <p class="countdownText">:</p>
                <div class="countdownLi">{{ seconds }}</div>
              </div>
            </div>

            <img class="pendant" src="../assets/image/pendant.png" alt />

            <!-- <div class="playGame" @click="loginFunc" v-if="!playGameStatus">
              <img src="../assets/image/login_btn.png" alt />
            </div>-->

            <div class="notice">
              <div class="noticeM">
                <div class="noticeT">
                  <img src="../assets/image/title3.png" alt />
                </div>

                <div class="redInfoT">
                  <div class="redInfoTLi">红包金额</div>
                  <div class="redInfoTLi">红包地址</div>
                  <div class="redInfoTLi">抢红包时间</div>
                </div>

                <div class="redInfoC">
                  <div class="redInfoCLi redInfo_1">
                    <p>
                      最高
                      <br />
                      <span>88888元</span>
                    </p>
                  </div>
                  <div class="redInfoCLi redInfo_2">
                    <p>
                      电脑手机均可
                      <br />登入
                      <span>asb3550hb.com</span>
                      <br />即可抢红包
                    </p>
                  </div>
                  <div class="redInfoCLi redInfo_3 redInfo_3_extra">
                    <p>
                      当天达到要求的会员请次日(北京时间12:00~23:59)开抢!(中奖后30分钟内自动派送)
                    </p>
                  </div>
                </div>

                <div class="read">
                  <div class="readLiP" style="text-align: center">
                    只要达到活动要求,即可参与抢金币,好运就在一瞬间发生,单个最高可达
                    <span>88888元</span>现金筹码。
                  </div>
                </div>

                <div class="table">
                  <div class="thead">
                    <div class="th">打码金额</div>
                    <div class="th">获赠抢红包机会</div>
                  </div>
                  <template v-for="(item, index) in ruleList">
                    <div class="tbody" :key="index">
                      <div class="td">{{ sumMoney(item.recharge) }}</div>
                      <div class="td">{{ item.count }}次</div>
                    </div>
                  </template>
                </div>
                <div class="read">
                  <div class="readLi">
                    注:会员必须达到指定的存款金额及有效投注才可以获得对应抢红包次数。若达到存款没有达到有效投注,则不计算抢红包次数!例如:会员当日存款50元+累计有效投注达到5万抢红包4次抢中红包:188元,888元,1888元,3888元,中奖后系统将于30分钟自动派送。
                  </div>
                </div>

                <div class="noticeT">
                  <img src="../assets/image/title1.png" alt />
                </div>

                <div class="read">
                  <div class="readLi">
                    1.会员当日存款50元且累计投注达到500元以上即可获得抢红包机会;
                  </div>
                  <div class="readLi">2.所获红包金额一倍流水,即可申请提款;</div>
                  <div class="readLi">
                    3.会员投注均由系统自动统计,若有任何异议,以爱色播为准;
                  </div>
                  <div class="readLi">
                    4.爱色播的所有优惠均是为玩家而设,同一账号,同一姓名,同一住址,同一IP,同一号码,同一银行卡账户均视为同一人,如发现任何团队或个人以不诚实的方式套取红利,威胁滥用公司优惠等行为,公司保留冻结并取消该团队或者个人账户及账户的结余权利;
                  </div>
                  <div class="readLi">
                    5.爱色播保留对活动的最终解释权,以及再无通知的情况下修改或终止活动的权利,适用于所有优惠。
                  </div>
                </div>
              </div>
            </div>
          </div>

          <img class="redAnimate1" src="../assets/image/redAnimate1.png" alt />
          <img class="redAnimate2" src="../assets/image/redAnimate2.png" alt />
        </div>
      </div>

      <div class="redRain">
        <div class="redRainLiWidth"></div>
        <template v-for="(item, index) in redRainArray">
          <img
            class="redRainLi"
            :src="item.src"
            :style="{ top: item.top, left: item.left, transition: item.speed }"
            :key="index"
          />
        </template>
      </div>

      <div class="redOperate" v-if="redStatus">
        <!-- 打开红包弹窗 -->
        <div class="openred" v-if="openredStatus">
          <img src="../assets/image/openred.png" alt />

          <div class="openredArea" @click="toGetRedFunc"></div>

          <div class="closeredArea" @click="closeredFunc"></div>
        </div>
        <!-- 获奖弹窗 -->
        <div class="getred" v-show="getredStatus">
          <img src="../assets/image/getred.png" alt />
          <p class="getredMoney">
            {{ winMoney }}
            <span>元</span>
          </p>
          <p class="getredTips">恭喜中奖！</p>
          <div class="getredArea" @click="getRedFunc">开心收下</div>

          <div class="closeGetRedArea" @click="closeGetredFunc"></div>
        </div>

        <!-- 失败弹窗 -->
        <div class="losered" v-if="loseredStatus">
          <img src="../assets/image/losered.png" alt />

          <div class="loseredArea" @click="loseredFunc"></div>
        </div>
      </div>
      <!-- 提示注册弹窗 -->
      <div class="register" v-if="registerStauts">
        <div class="registerTips">
          <img src="../assets/image/register.png" alt />

          <div class="registerYes" @click="registerFunc">立即注册</div>
          <div class="registerNo" @click="closeRegister"></div>
          <div class="registerClose" @click="closeRegister"></div>
        </div>
      </div>
    </div>

    <img
      v-if="playGameStatus"
      @click="logoutFunc"
      class="logout"
      src="../assets/image/logout.png"
      alt=""
    />

    <!-- appid获取教程 -->
    <div class="tutorialAlert" v-if="tutorialStatus">
      <div class="tutorialAlertTips">
        <img src="../assets/image/tutorial.png" alt />

        <div class="closeTutorialIcon" @click="closeTutorial"></div>
      </div>
    </div>

    <!-- 裸聊奖品 -->
    <div class="award" v-if="awardStatus">
      <div class="awardAlert">
        <img
          v-show="awardType == 'GIFT1'"
          src="../assets/image/GIFT1.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT2'"
          src="../assets/image/GIFT2.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT3'"
          src="../assets/image/GIFT3.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT4'"
          src="../assets/image/GIFT4.png"
          @click="openliao"
          alt
        />
        <img
          v-show="awardType == 'GIFT5'"
          src="../assets/image/GIFT5.png"
          @click="openliao"
          alt
        />

        <div class="closeawardArea" @click="closeliao"></div>
      </div>
    </div>

    <div class="recordPage" v-show="recordStatus">
      <div class="record">
        <img class="recordTitle" src="../assets/image/title2.png" alt />
        <div class="recordT">
          <p style="width: 25%">日期</p>
          <p style="width: 22%">次数</p>
          <p style="width: 28%">金额获得</p>
          <p style="width: 25%">红包状态</p>
        </div>
        <div class="recordC" @scroll="handleScroll">
          <div class="recordScroll">
            <template v-for="(item, index) in recordList">
              <div class="recordLi" :key="index">
                <div class="recordTd" style="width: 25%">
                  {{ formatDateTime(item.receiveTime) }}
                </div>
                <div class="recordTd" style="width: 22%">
                  第{{ item.lotteryCount || 0 }}次
                </div>
                <div class="recordTd" style="width: 28%">
                  获得{{ item.rewardAmount }}红包
                </div>
                <div class="recordTd" style="width: 25%">
                  {{ item.dispatchStatusDesc }}
                </div>
              </div>
            </template>

            <div class="recordLiHeight"></div>
          </div>
        </div>

        <div class="backArea" @click="back"></div>
      </div>

      <!-- <div class="turnArea"></div> -->
    </div>

    <div
      class="playGameRecord"
      @click="toRecord"
      v-if="playGameStatus && indexStatus"
    >
      <img src="../assets/image/red_record.png" alt />
    </div>
  </div>
</template>

<script>
import {
  getPacket,
  getHistory,
  getRemainCount,
  authLogin,
  getConfig,
  getRule,
  getLogout,
} from "@/api/red";

import { Message } from "element-ui";
import { getToken, setToken, removeToken } from "@/utils/request";
import redImg from "../assets/image/red.png";

const ACCOUNT_KEY = "aisebo_red_account";

export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  data() {
    return {
      indexStatus: true,
      redTimer: null,
      redRainArray: [],
      registerStauts: false,
      playGameStatus: false,
      redStatus: false,
      openredStatus: false,
      getredStatus: false,
      loseredStatus: false,
      recordStatus: false,
      tutorialStatus: false,
      awardStatus: false,
      huiyinniaoUrl: "",
      prizeNum: 0,
      winMoney: 0,
      step: 0,
      recordTimer: null,
      ruleList: [],
      recordList: [],
      vipAccount: "",
      registerUrl: "",
      hours: 0,
      minutes: 0,
      seconds: 0,

      isLoadingMore: false, // 是否正在加载更多
      recordNum: 1, // 当前页码
      hasMore: true, // 是否还有更多数据
      activityId: "",
    };
  },
  mounted() {
    setInterval(() => {
      this.hours = this.countdown().hours;
      this.minutes = this.countdown().minutes;
      this.seconds = this.countdown().seconds;
    }, 1000);
    // 规则
    getRule().then((res) => {
      this.ruleList = res.data;
    });

    // 配置地址
    getConfig().then((res) => {
      res.data.forEach((v) => {
        if (v.key == "hyn_url") {
          this.huiyinniaoUrl = v.value;
        }
        if (v.key == "registration_link") {
          this.registerUrl = v.value;
        }
      });
    });

    // 判断url是否有值，有的话直接登录
    const userAccount = this.getUrlUserAccount("userAccount");
    if (userAccount) {
      this.vipAccount = userAccount;
      this.loginFunc();
    } else {
      this.restoreLogin();
    }
  },

  methods: {
    // 获取url参数的值
    getUrlUserAccount(name) {
      const queryString =
        window.location.search ||
        (window.location.hash.includes("?")
          ? window.location.hash.slice(window.location.hash.indexOf("?"))
          : "");

      return new URLSearchParams(queryString).get(name)?.trim() || "";
    },
    // 检测是否有登录状态
    restoreLogin() {
      const token = getToken();
      const account = localStorage.getItem(ACCOUNT_KEY);
      if (!token || !account) return;
      this.vipAccount = account;

      getRemainCount()
        .then((res) => {
          if (res.code !== 200) {
            removeToken();
            localStorage.removeItem(ACCOUNT_KEY);
            this.vipAccount = "";
            this.registerStauts = true;
            return;
          }

          localStorage.setItem(ACCOUNT_KEY, this.vipAccount);

          this.prizeNum = res.data.count;
          this.playGameStatus = true;
          this.activityId = res.data.activityId;
        })
        .catch(() => {
          removeToken();
          localStorage.removeItem(ACCOUNT_KEY);
          this.vipAccount = "";
        });
    },
    // 红包雨动画
    redRainFunc() {
      this.redRainArray = [];
      let owindow_width = document.documentElement.clientWidth;
      window.onresize = () => {
        return (() => {
          owindow_width = document.documentElement.clientWidth;
        })();
      };

      let redWidth = document.querySelector(".redRainLiWidth").offsetWidth;

      clearInterval(this.redTimer);
      this.redTimer = setInterval(() => {
        let red1 = parseInt(Math.random() * (owindow_width - redWidth));
        let red2 = parseInt(Math.random() * redWidth * 2 + 1);
        let speed = parseInt(Math.random() * 3 + 10);

        this.redRainArray.push({
          src: redImg,
          left: red1 + "px",
          top: 0,
          speed: 0,
        });

        if (this.redRainArray[this.redRainArray.length - 2]) {
          this.redRainArray[this.redRainArray.length - 2] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
        }

        if (this.redRainArray.length > 25) {
          // this.redRainArray = []
          this.redRainArray[this.redRainArray.length - 1] = {
            src: redImg,
            top: 4000 + "px",
            left: red1 - red2,
            speed: speed + "s all",
          };
          clearInterval(this.redTimer);
        }
      }, 200);

      // setTimeout(() => {
      //   this.redRainArray = []
      //   clearInterval(this.redTimer)
      // }, 5000)
    },
    // 抢红包
    loginFunc() {
      if (!this.vipAccount) {
        Message({
          message: "请输入您的ID！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }
      // 判断是否已经登录完成 如果是就默认直接开始游戏
      if (this.playGameStatus) {
        this.playGameFunc();
      } else {
        // 进行登录
        authLogin({ accountName: this.vipAccount }).then((res) => {
          console.log(res);

          if (res.code !== 200) {
            this.registerStauts = true;
            this.loginStatus = true;
          } else {
            // 保存 token 到全局
            if (res.data && res.data.token) {
              setToken(res.data.token);
              console.log("Token 已保存:", res.data.token);
            }

            localStorage.setItem(ACCOUNT_KEY, this.vipAccount);

            // 获取红包次数
            getRemainCount().then((res) => {
              // if (res.data.count === 0) {
              //   llRemainCount({
              //     appid: process.env.VUE_APP_APPID,
              //     username: this.vipAccount,
              //   }).then((res) => {
              //     this.luoliaoStatus = true;
              //     this.prizeNum = res.data.count;
              //     this.playGameStatus = true;
              //   });
              // } else {
              //   this.prizeNum = res.data.count;
              //   this.playGameStatus = true;
              // }

              this.prizeNum = res.data.count;
              this.playGameStatus = true;

              this.activityId = res.data.activityId;
            });
          }
        });
      }
    },
    // 开始游戏
    playGameFunc() {
      if (this.prizeNum == 0) {
        Message({
          message: "没有抽奖次数！",
          type: "warning",
          duration: 5 * 1000,
        });
        return false;
      }

      this.redRainFunc();

      setTimeout(() => {
        this.redStatus = true;
        this.openredStatus = true;
      }, 3000);
    },
    // 关闭拆红包界面
    closeredFunc() {
      this.redStatus = false;
      this.openredStatus = false;

      // 关掉红包雨
      this.redRainArray = [];
      clearInterval(this.redTimer);
    },
    // 关闭收红包界面
    closeGetredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 去拆完红包界面
    toGetRedFunc() {
      if (this.luoliaoStatus) {
        // getllAward({
        //   appid: process.env.VUE_APP_APPID,
        //   username: this.vipAccount,
        // }).then((res) => {
        //   this.openredStatus = false;
        //   this.awardStatus = true;
        //   this.winMoney = 0;
        //   this.prizeNum = 0;
        //   this.awardType = res.data.money;
        // });
      } else {
        getPacket(this.activityId).then((res) => {
          // 判断是否中奖
          if (res.data.money == 0) {
            this.openredStatus = false;
            this.loseredStatus = true;
          } else {
            this.openredStatus = false;
            this.getredStatus = true;
            this.winMoney = res.data.money;
          }
          this.prizeNum = res.data.count;
        });
      }
    },
    // 打开教程
    toTutorial() {
      this.tutorialStatus = true;
    },
    // 关闭获取教程弹窗
    closeTutorial() {
      this.tutorialStatus = false;
    },
    // 收下红包
    getRedFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.getredStatus = false;
    },
    // 未中奖
    loseredFunc() {
      this.redStatus = false;
      this.openredStatus = false;
      this.loseredStatus = false;
    },
    // 跳转注册
    registerFunc() {
      window.open(this.registerUrl);
    },
    // 关闭注册
    closeRegister() {
      this.registerStauts = false;
    },
    // 跳转抽奖记录
    toRecord() {
      this.recordStatus = true;
      this.indexStatus = false;

      this.recordNum = 1;
      this.recordList = [];
      this.isLoadingMore = false;
      this.hasMore = true;
      this.historyRecord();
    },

    // 返回抽奖大厅
    back() {
      this.clearRecordTimer();

      this.recordStatus = false;
      this.indexStatus = true;
    },
    // 红包记录
    historyRecord() {
      if (this.isLoadingMore || !this.hasMore) return;
      this.isLoadingMore = true;

      getHistory({
        activityType: 6,
        pageNo: this.recordNum,
        pageSize: 10,
      }).then((res) => {
        this.recordList.push(...res.rows);
        this.recordNum += 1;
        // 如果新数据长度小于pageSize，则说明没有更多数据
        this.hasMore = res.rows.length === 10;
        this.isLoadingMore = false;
      });
    },
    // 红包记录滚动
    handleScroll(event) {
      event.preventDefault();

      const { scrollTop, scrollHeight, clientHeight } = event.target;
      // 当滚动到底部时加载更多
      if (scrollTop + clientHeight >= scrollHeight - 5 && this.hasMore) {
        this.historyRecord();
      }
    },
    openliao() {
      window.location.href = this.huiyinniaoUrl;
    },
    closeliao() {
      this.awardStatus = false;
      this.redStatus = false;
    },
    // 清除文字滚动
    clearRecordTimer() {
      clearInterval(this.recordTimer);
    },
    // 红包倒计时
    countdown() {
      const now = new Date();
      const nextDay = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate() + 1,
      );
      const difference = nextDay - now; // 计算时间差（毫秒）

      // 将时间差转换为时分秒格式
      const seconds = Math.floor((difference / 1000) % 60)
        .toString()
        .padStart(2, "0");

      const minutes = Math.floor((difference / 1000 / 60) % 60)
        .toString()
        .padStart(2, "0");
      const hours = Math.floor((difference / 1000 / 60 / 60) % 24)
        .toString()
        .padStart(2, "0");

      // 返回格式化的剩余时间
      return {
        hours,
        minutes,
        seconds,
      };
    },
    // 转化金额单位
    sumMoney(val) {
      let result = "";
      if (val < 10000) {
        result = val + "元+";
      } else {
        result = Math.floor(val / 10000) + "万+";
      }
      return result;
    },
    // 退出登录
    logoutFunc() {
      getLogout().then((res) => {
        Message({
          message: res.msg,
          type: "warning",
          duration: 5 * 1000,
        });
        removeToken();
      });

      localStorage.removeItem(ACCOUNT_KEY);
      this.vipAccount = "";
      this.playGameStatus = false;
    },
    // 格式化日期时间
    formatDateTime(timestamp) {
      if (!timestamp) return "";

      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      // const hours = String(date.getHours()).padStart(2, "0");
      // const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.bg {
  position: relative;
}
.Index {
  position: relative;
}

.banner {
  position: relative;
  height: 1186px;
  .bannerBg {
    width: 100%;
  }

  .bannerTitle {
    width: 434px;
    position: absolute;
    transform: translate(-50%, 0);
    top: 45px;
    left: 50%;
    z-index: 1;
  }

  .theme {
    background: url("../assets/image/theme.png") no-repeat;
    background-size: 100% 100%;
    width: 540px;
    height: 686px;
    position: absolute;
    transform: translate(-50%, 0);
    top: 320px;
    left: 50%;

    .themeContent {
      position: absolute;
      top: 663px;
      left: 50%;
      transform: translate(-50%, 0);
      width: 100%;
      .count {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 422px;
        margin: 5px auto 15px;

        .countTitle {
          background: url("../assets/image/noLimit.png") no-repeat;
          background-size: 100% 100%;
          width: 125px;
          height: 26px;
          color: #fff;
          font-weight: bold;
        }
        .countdown {
          display: flex;
          align-items: center;

          .countdownTitle {
            color: #9a4287;
            font-size: 21px;
            margin-right: 5px;
          }

          .countdownLi {
            color: #fff;
            font-size: 21px;
            background: #ff549c;
            border-radius: 5px;
            padding: 4px;
          }
          .countdownText {
            color: #9a4287;
            margin: 0 2px;
            font-size: 26px;
            line-height: 26px;
          }
        }
      }

      .pendant {
        width: 482px;
      }

      .playGame {
        .playGameNum {
          width: 341px;
          height: 50px;
          line-height: 50px;
          color: #ae1903;
          font-size: 23px;
          position: absolute;
          top: -168px;
          left: 103px;
        }
        img {
          width: 432px;
          cursor: pointer;
          margin-top: 10px;
        }
      }
    }

    .themeInput {
      background: url("../assets/image/themeInput1.png") no-repeat;
      background-size: 100% 100%;
      width: 302px;
      height: 73px;
      position: absolute;
      top: 490px;
      left: 120px;

      .getAPPID {
        margin-top: 13px;
        font-size: 21px;
        position: absolute;
        top: 72px;
        left: 26px;
        color: #fff;
        width: 251px;
        span {
          color: #ffe041;
        }
      }

      input {
        background: none;
        border: 0;
        color: #ae1903;
        font-size: 25px;
        width: 302px;
        text-align: center;
        margin-top: 14px;
        &::placeholder {
          color: #ae1903;
          font-size: 25px;
        }
      }
      input[type="text"]:focus {
        outline: none;
      }
    }

    .liaoIcon {
      position: absolute;
      top: -258px;
      left: 1px;
      width: 553px;
    }

    .rob {
      position: absolute;
      top: 325px;
      left: 199px;
      width: 152px;
      height: 147px;
      border-radius: 50%;
      cursor: pointer;
    }

    .redAnimate1 {
      width: 115px;
      position: absolute;
      top: 12px;
      left: 19px;
      animation: red1 1.5s ease-in infinite normal;
    }

    @keyframes red1 {
      from {
        top: -50px;
        left: 160px;
        transform: scale(0.2);
      }
      to {
        top: 12px;
        left: 19px;
        transform: scale(1);
      }
    }

    .redAnimate2 {
      width: 105px;
      position: absolute;
      top: 54px;
      left: 392px;
      animation: red2 1.5s ease-in infinite normal;
    }

    @keyframes red2 {
      from {
        top: -60px;
        left: 312px;
        transform: scale(0.2);
      }
      to {
        top: 54px;
        left: 392px;
        transform: scale(1);
      }
    }
  }
}

.notice {
  height: 1000px;
  margin-top: 20px;
  .noticeT {
    position: relative;
    margin: 30px 0 5px 0;
    img {
      width: 330px;
    }
    p {
      font-size: 60px;
      line-height: 60px;
      color: #fcf4c6;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin-left: 14px;
    }
  }
  .noticeM {
    background: url("../assets/image/notice_m.png") no-repeat;
    background-size: 100%;
    min-height: 1564px;
    overflow: hidden;
    .read {
      text-align: left;
      .readLi {
        color: #ffffff;
        font-size: 15px;
        width: 458px;
        margin: 0 auto;
        text-align: justify;
      }

      .readLiP {
        color: #ffffff;
        font-size: 15px;
        width: 438px;
        margin: 0 auto;
        span {
          color: #feff58;
          font-weight: bold;
        }
      }
    }

    .redInfoT {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 458px;
      margin: 20px auto 0;
      .redInfoTLi {
        font-size: 18px;
        line-height: 36px;
        background: linear-gradient(180deg, #f981df, #e54fc2);
        color: #fff;
        width: 146px;
        height: 36px;
        border-radius: 6px;
      }
    }

    .redInfoC {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 458px;
      margin: 20px auto;
      .redInfoCLi {
        width: 146px;
        height: 218px;
        border-radius: 15px;
        p {
          color: #ffffff;
          margin-top: 15px;
        }
      }
      .redInfo_1 {
        background: url("../assets/image/redInfo_1.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
        font-size: 21px;
        span {
          font-size: 21px;
          font-weight: bold;
          color: #feff58;
        }
      }
      .redInfo_2 {
        background: url("../assets/image/redInfo_2.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
        font-size: 17px;
        span {
          font-size: 17px;
          font-weight: bold;
          color: #feff58;
        }
      }
      .redInfo_3 {
        background: url("../assets/image/redInfo_3.png") no-repeat;
        background-size: contain;
        background-position: bottom right;
        font-size: 15px;
      }
      .redInfo_3_extra {
        text-align: left;
        padding: 0px 15px;
        box-sizing: border-box;
        word-break: break-all;
      }
    }
  }
  .noticeB {
    width: 100%;
  }

  .table {
    border: 1px solid #ee887d;
    width: 458px;
    margin: 30px auto 15px;
    border-radius: 20px;
    .thead {
      display: flex;
      align-items: center;
      width: 100%;
      height: 50px;
      background: linear-gradient(180deg, #b84b91, #ae3e57);
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
      .th {
        flex: 1;
        flex-shrink: 0;
        color: #fff;
        font-size: 24px;
        min-height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .th:last-child {
        border-right: 0;
      }
    }

    .tbody {
      display: flex;
      width: 100%;
      .td {
        flex: 1;
        flex-shrink: 0;
        color: #fff;
        font-size: 21px;
        border-right: 1px solid #ee887d;
        border-bottom: 1px solid #ee887d;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .td:last-child {
        border-right: none;
      }
    }

    .tbody:last-child {
      .td {
        border-bottom: none;
      }
    }
  }
}

.turn {
  width: 100%;
}

.redRain {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  .redRainLi {
    position: absolute;
    width: 86px;
  }
  .redRainLiWidth {
    position: fixed;
    top: -10000px;
    left: -10000px;
    width: 100px;
  }
}

.redOperate {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;

  .openred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 437px;
    }
    .openredArea {
      position: absolute;
      left: 149px;
      top: 92px;
      width: 140px;
      height: 140px;
      cursor: pointer;
    }
    .closeredArea {
      background: url("../assets/image/close.png") no-repeat;
      background-size: 100%;
      width: 55px;
      height: 55px;
      position: absolute;
      right: 16px;
      top: -99px;
      cursor: pointer;
    }
  }
  .getred {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 417px;
    }
    .getredArea {
      background: url("../assets/image/themeInput.png") no-repeat;
      background-size: 100%;
      position: absolute;
      left: 22px;
      bottom: -79px;
      width: 365px;
      height: 73px;
      color: #a72200;
      font-size: 25px;
      cursor: pointer;
      border-radius: 25px;
      line-height: 61px;
    }

    .closeGetRedArea {
      background: url("../assets/image/close.png") no-repeat;
      background-size: 100%;
      width: 55px;
      height: 55px;
      position: absolute;
      right: 16px;
      top: -75px;
      cursor: pointer;
    }

    .getredMoney {
      font-size: 116px;
      position: absolute;
      left: 50%;
      top: 103px;
      transform: translate(-50%, 0);
      height: 116px;
      line-height: 116px;
      font-weight: bold;
      color: #f12d0a;
      span {
        position: absolute;
        right: -26px;
        bottom: 20px;
        font-size: 29px;
        line-height: 20px;
        display: block;
        color: #ff2900;
        background: none;
        -webkit-text-fill-color: #ff2900;
      }
    }
    .getredTips {
      position: absolute;
      transform: translate(-50%, 0);
      left: 50%;
      top: 203px;
      font-size: 57px;
      color: #f12d0a;
      width: 100%;
      margin-left: 25px;
    }
  }

  .losered {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 417px;
    }
    .loseredArea {
      position: absolute;
      left: 75px;
      bottom: 190px;
      width: 267px;
      height: 68px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.register {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.5);

  .registerTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    img {
      width: 480px;
    }
    .registerYes {
      background: url("../assets/image/themeInput.png") no-repeat;
      background-size: 100%;
      position: absolute;
      left: 50%;
      bottom: -95px;
      width: 365px;
      height: 73px;
      color: #a72200;
      font-size: 25px;
      cursor: pointer;
      border-radius: 25px;
      line-height: 61px;
      transform: translate(-50%, 0);
    }
    .registerClose {
      background: url("../assets/image/close.png") no-repeat;
      background-size: 100%;
      width: 55px;
      height: 55px;
      position: absolute;
      right: 35px;
      top: -19px;
      cursor: pointer;
    }
  }
}

.recordPage {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  .record {
    background: linear-gradient(45deg, #ffffff, #ff7f6e);
    border-radius: 30px;
    width: 480px;
    height: 463px;
    position: absolute;
    left: 50%;
    top: 183px;
    transform: translate(-50%, 0);
    .recordTitle {
      width: 330px;

      margin-top: -30px;
    }
    .recordT {
      width: 452px;
      height: 34px;
      display: flex;
      align-items: center;
      background-color: rgba(179, 117, 109, 0.5);
      margin: 15px auto 10px;
      border-radius: 18px;
      p {
        color: #fff;
        font-size: 18px;
      }
    }
    .recordC {
      width: 480px;
      height: 270px;
      overflow-y: auto;
      position: absolute;
      top: 87px;
      left: 0;
      .recordScroll {
        width: 100%;
        .recordLi {
          display: flex;
          align-items: center;
          height: 29px;
          .recordTd {
            color: #7e2115;
            font-size: 15px;
            padding-bottom: 15px;
          }
        }
      }

      .recordLiHeight {
        position: fixed;
        top: -10000px;
        left: -10000px;
        height: 65px;
      }
    }
  }

  .backArea {
    position: absolute;
    top: -96px;
    right: 1px;
    background: url("../assets/image/close.png") no-repeat;
    background-size: 100%;
    width: 55px;
    height: 55px;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
  }

  .turnArea {
    position: absolute;
    bottom: 95px;
    left: 30px;
    width: 1020px;
    height: 75px;
    cursor: pointer;
  }
}

.playGameRecord {
  position: fixed;
  right: 0;
  top: 35%;
  transform: translate(0, -50%);
  cursor: pointer;
  img {
    width: 42px;
  }
}

.marquee {
  position: relative;
  transition: top 0.2s linear;
}

.tutorialAlert {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 6;

  .tutorialAlertTips {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 500px;
    }
    .tutorialAlertYes {
      position: absolute;
      left: 76px;
      bottom: 144px;
      width: 248px;
      height: 62px;
      cursor: pointer;
      border-radius: 12px;
    }
    .closeTutorialIcon {
      position: absolute;
      right: 14px;
      top: 12px;
      width: 40px;
      height: 40px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.award {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;

  .awardAlert {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;

    img {
      width: 450px;
    }

    .awardLiao {
      position: absolute;
      left: 75px;
      bottom: 88px;
      width: 298px;
      height: 60px;
      cursor: pointer;
      border-radius: 25px;
    }

    .awardArea {
      position: absolute;
      left: 40px;
      bottom: 104px;
      width: 372px;
      height: 66px;
      cursor: pointer;
      border-radius: 25px;
    }

    .closeawardArea {
      position: absolute;
      right: 194px;
      bottom: 2px;
      width: 61px;
      height: 63px;
      cursor: pointer;
      border-radius: 25px;
    }
  }
}

.logout {
  position: absolute;
  right: 10px;
  top: 20px;
  width: 140px;
  height: 30px;
  z-index: 1;
}
</style>
